import React, { memo } from 'react';
import { FaMask } from 'react-icons/fa'; // Ícono de antifaz
import { LiaBirthdayCakeSolid } from 'react-icons/lia';
import ImageCardModel from './ImageCardModel';

const CardModel = memo(({ model, index }) => {
    // Tarjeta estilo Apple: la foto ocupa todo, sin borde, con un degradado
    // abajo para que el nombre y la edad se lean sobre cualquier imagen.
    return (
        <div
            className="relative overflow-hidden rounded-[24px] transition-transform duration-300 ease-out hover:scale-[1.015] active:scale-[0.99]"
            style={{
                width: '300px',
                height: '400px',
                fontFamily: 'var(--ap-font)',
                background: 'var(--ap-surface)',
                boxShadow: '0 1px 2px rgba(0,0,0,.06), 0 12px 32px rgba(0,0,0,.14)',
            }}
        >
            <ImageCardModel
                files={model.files}
                className="w-full h-full object-cover"
            />
            <div
                className="absolute inset-x-0 bottom-0 flex items-end justify-between gap-3 px-4 pb-4 pt-16 text-white"
                style={{ background: 'linear-gradient(to top, rgba(0,0,0,.72), rgba(0,0,0,.35) 55%, transparent)' }}
            >
                <span className="flex items-center gap-1.5 min-w-0">
                    <FaMask className="shrink-0 text-lg" style={{ color: 'var(--ap-tint)' }} />
                    <span className="truncate text-[15px] leading-5 font-medium tracking-[-0.01em]" translate="no">{model.nickname}</span>
                </span>
                {model.age && (
                    <span className="ap-material shrink-0 inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-[12px] font-medium" style={{ background: 'rgba(255,255,255,.2)' }}>
                        <LiaBirthdayCakeSolid className="text-base" />
                        {model.age}
                    </span>
                )}
            </div>
        </div>
    );
}, (prevProps, nextProps) => {
    // Comparación personalizada para evitar re-renders innecesarios
    return prevProps.model.id === nextProps.model.id && 
           prevProps.model.files === nextProps.model.files &&
           prevProps.model.nickname === nextProps.model.nickname &&
           prevProps.model.age === nextProps.model.age;
});

CardModel.displayName = 'CardModel';

export default CardModel;